import { useState } from "react";
import { BookOpen, ChevronDown, Lock, Package } from "lucide-react";
import { LORE_PAGES } from "../../data/dolopals";
import { SectionHeading } from "../SectionHeading";

export function LoreVault({ fragments }) {
  const [openId, setOpenId] = useState(null);
  return (
    <section className="lore-vault" data-testid="lore-vault">
      <SectionHeading
        eyebrow="LORE VAULT // READABLE DROPS"
        title="Fragment stories."
        text="Lore fragments from the Ghost Tower decrypt into real story pages. Every fragment cracks the vault one entry deeper — the tower grind pays off in bedtime reading."
      />
      <p className="lore-progress" data-testid="lore-progress">
        <Package size={13} /> {fragments} FRAGMENT{fragments === 1 ? "" : "S"} RECOVERED — {LORE_PAGES.filter((l) => fragments >= l.unlockAt).length}/{LORE_PAGES.length} PAGES DECRYPTED
      </p>
      <div className="lore-list">
        {LORE_PAGES.map((page) => {
          const locked = fragments < page.unlockAt;
          const isOpen = openId === page.id && !locked;
          return (
            <article key={page.id} className={`lore-entry ${locked ? "is-locked" : ""} ${isOpen ? "is-open" : ""}`} data-testid={`lore-entry-${page.id}`}>
              <button
                type="button"
                className="lore-toggle"
                onClick={() => setOpenId(isOpen ? null : page.id)}
                disabled={locked}
                data-testid={`lore-toggle-${page.id}`}
              >
                {locked ? <Lock size={14} /> : <BookOpen size={14} />}
                <span className="lore-toggle-title">{locked ? `ENCRYPTED PAGE — NEEDS ${page.unlockAt} FRAGMENT${page.unlockAt > 1 ? "S" : ""}` : page.title}</span>
                {!locked ? <ChevronDown size={14} className="lore-chevron" /> : null}
              </button>
              {isOpen ? (
                <div className="lore-body" data-testid={`lore-body-${page.id}`}>
                  <em>RECOVERED BY // {page.pal}</em>
                  <p>{page.text}</p>
                </div>
              ) : null}
            </article>
          );
        })}
      </div>
    </section>
  );
}

/* Critter Book — the scrap-critter field guide: adopted ones in color, the rest as true-shape silhouettes */
